
import { Form, Input, InputNumber, Radio, Spin } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';
import { shouldComponentBeVisible } from '../../utils/evaluateCondition';
import globalGetPadding from '../../utils/getPadding';
import { getFieldOptionsByCode } from '../../../../api/customForm';
import { getMerchantCode, getMerchantCode2, shallowEqualIgnoreOrder } from '../../utils/commonFun';
import { getBorderRadiusValue } from '../../utils/borderRadius';

function getFontFamily(fontFamily) {
    switch (fontFamily) {
        case 'MODERN_SANS':
            return '"Helvetica Neue", "Arial Nova", "Nimbus Sans", Arial, sans-serif';
        case 'BOOK_SANS':
            return 'Optima, Candara, "Noto Sans", source-sans-pro, sans-serif';
        case 'ORGANIC_SANS':
            return 'Seravek, "Gill Sans Nova", Ubuntu, Calibri, "DejaVu Sans", source-sans-pro, sans-serif';
        case 'GEOMETRIC_SANS':
            return 'Avenir, "Avenir Next LT Pro", Montserrat, Corbel, "URW Gothic", source-sans-pro, sans-serif';
        case 'HEAVY_SANS':
            return 'Bahnschrift, "DIN Alternate", "Franklin Gothic Medium", "Nimbus Sans Narrow", sans-serif-condensed, sans-serif';
        case 'ROUNDED_SANS':
            return 'ui-rounded, "Hiragino Maru Gothic ProN", Quicksand, Comfortaa, Manjari, "Arial Rounded MT Bold", Calibri, source-sans-pro, sans-serif';
        case 'MODERN_SERIF':
            return 'Charter, "Bitstream Charter", "Sitka Text", Cambria, serif';
        case 'BOOK_SERIF':
            return '"Iowan Old Style", "Palatino Linotype", "URW Palladio L", P052, serif';
        case 'MONOSPACE':
            return '"Nimbus Mono PS", "Courier New", "Cutive Mono", monospace';
        default:
            return undefined;
    }
}

export const RadioPropsDefaults = {
    label: '',
    name: '',
    inline: 'Yes',
    optionGap: 8,
    optionType: 'default',
    options: [],
    required: false,
    visible: {
        alwaysShow: true,
        conditions: []
    },
    isFormItem: true,
    disabled: false
};
export const FormRadio = (_a)=> {
    const rootData = _a.form_data.root;
    const root_formStyle = rootData?.data?.formStyle;
    const root_formMessage = rootData?.data?.messageData;
    const isMobile = _a.formClientWidth <= 480;
    var _b, _c, _d, _e, _f, _bb, _cc, _dd;
    var style = _a.style;
    var wStyle = {
        backgroundColor: (_c = style === null || style === void 0 ? void 0 : style.backgroundColor) !== null && _c !== void 0 ? _c : undefined,
        padding: globalGetPadding(style === null || style === void 0 ? void 0 : style.padding, isMobile),
        borderRadius: getBorderRadiusValue((_f = style === null || style === void 0 ? void 0 : style.borderRadius) !== null && _f !== void 0 ? _f : undefined),
    };
    var labelStyle = {
        color: (_b = style === null || style === void 0 ? void 0 : style.color) !== null && _b !== void 0 ? _b : undefined,
        fontSize: (_d = style === null || style === void 0 ? void 0 : style?.fontSize) !== null && _d !== void 0 ? (isMobile ? _d/1.1 : _d) : undefined,
        fontFamily: getFontFamily(style === null || style === void 0 ? void 0 : style.fontFamily),
        fontWeight: (_e = style === null || style === void 0 ? void 0 : style.fontWeight) !== null && _e !== void 0 ? _e : undefined,
    }
    var optionLabelStyle = {
        color: (_bb = style === null || style === void 0 ? void 0 : style.optionLabelColor) !== null && _bb !== void 0 ? _bb : undefined,
        fontSize: (_cc = style === null || style === void 0 ? void 0 : style?.optionLabelFontSize) !== null && _cc !== void 0 ? (isMobile ? _cc/1.1 : _cc) : undefined,
        fontWeight: (_dd = style === null || style === void 0 ? void 0 : style.optionLabelFontWeight) !== null && _dd !== void 0 ? _dd : undefined,
    }
    // var text = (_g = props === null || props === void 0 ? void 0 : props.text) !== null && _g !== void 0 ? _g : TextPropsDefaults.text;
    // return <div style={wStyle}>
    //     {text}
    // </div>;

    var _g, _h, _i, _j, _k, _l, _m;
    var props = _a.props;
    var label = (_g = props === null || props === void 0 ? void 0 : props.label) !== null && _g !== void 0 ? _g : RadioPropsDefaults.label;
    var name = (_h = props === null || props === void 0 ? void 0 : props.name) !== null && _h !== void 0 ? _h : RadioPropsDefaults.name;
    var options = (_j = props === null || props === void 0 ? void 0 : props.options) !== null && _j !== void 0 ? _j : RadioPropsDefaults.options;
    var required = (_k = props === null || props === void 0 ? void 0 : props.required) !== null && _k !== void 0 ? _k : RadioPropsDefaults.required;
    var visible = (_l = props === null || props === void 0 ? void 0 : props.visible) !== null && _l !== void 0 ? _l : RadioPropsDefaults.visible;
    var disabled = (_m = props === null || props === void 0 ? void 0 : props.disabled) !== null && _m !== void 0 ? _m : RadioPropsDefaults.disabled;

    const formStyle = _a.formStyle;
    const item_layout = !formStyle?.layout && root_formStyle?.layout ? root_formStyle?.layout : formStyle?.layout ? 
        formStyle?.layout : '';
    const item_colon = formStyle?.colon === undefined && root_formStyle?.colon !== undefined ? root_formStyle?.colon : formStyle?.colon;
    const inline = (_i = formStyle === null || formStyle === void 0 ? void 0 : formStyle.inline) !== null && _i !== void 0 ? _i : RadioPropsDefaults.inline;
    const optionGap = formStyle?.optionGap !== null && formStyle?.optionGap !== void 0 ? formStyle?.optionGap : RadioPropsDefaults.optionGap;
    const optionType = formStyle?.optionType !== null && formStyle?.optionType !== void 0 ? formStyle?.optionType : RadioPropsDefaults.optionType;

    const requiredText = props?.requiredText !== null && props?.requiredText !== void 0 ? props?.requiredText : root_formMessage?.required;
    
    const [fieldHidden, setFieldHidden] = useState(false);
    const [fieldLoading, setFieldLoading] = useState(false);
    const [lastDependFields, setLastDependFields] = useState({});
    const [dependFields, setDependFields] = useState({});
    const [getOptions, setGetOptions] = useState(_a?.props?.options || []);
    const calVisible = useMemo(()=>{
        if(visible?.alwaysShow) {
            return true;
        }
        else {
            return shouldComponentBeVisible(visible?.conditions, _a?.allFieldValues);
        }
    }, [visible, _a?.allFieldValues])

    useEffect(()=>{
        if(!calVisible && _a?.formRef && !_a?.props?.hiddenOnly) {
            _a?.formRef.setFieldValue(name, undefined);
            _a.setAllFieldValues && _a.setAllFieldValues(prevData=>({
                ...prevData,
                [name]: {
                    value: undefined,
                    isRequired: prevData[name]?.isRequired,
                    type: prevData[name]?.type
                }
            }))
        }
    }, [calVisible])

    useEffect(()=>{
        const fetchData = async () => {
            let res = [];
            if(_a?.fieldSource?.type === 'api' && _a?.fCode) {
                //如果options是通过api获取，走这里�?
                if(!fieldLoading) {
                    let dependValues = {};
                    let fullField = true;
                    if(_a?.fieldSource?.depends?.length) {
                        //需要获取其他字段的值来决定options，才发请�?
                        _a?.fieldSource?.depends?.forEach(item=>{
                            if(!dependFields[item.fromField]) {
                                fullField = false;
                            }
                            else if((dependFields[item.fromField]?.isRequired && dependFields[item.fromField]?.value) || !dependFields[item.fromField]?.isRequired) {
                                dependValues[item.targetParam] = dependFields[item.fromField]?.value;
                            }
                            else {
                                fullField = false;
                            }
                        })
                    }
                    if(fullField) {
                        setFieldLoading(true);
                        const merchantCode = getMerchantCode(_a?.cmCode, 'form');
                        const getRes = await getFieldOptionsByCode({
                            "formCode": _a?.fCode,
                            "fieldCode": name,
                            "dependValues": dependValues
                        }, merchantCode || getMerchantCode2(_a?.cmCode), merchantCode ? null : 'form').catch(error => {
                            return null; // 必须 return，否�?getRes �?undefined
                        });
                        setFieldLoading(false);
                        if(getRes?.options) {
                            res = getRes.options.filter(item=>!item.disabled);
                        }
                    }
                }
            }
            else {
                //原来获取options的方�?
                options?.forEach(item=>{
                    if(item.isRely && item.relyField) {
                        if(_a?.allFieldValues[item.relyField]?.value === item.relyValue) {
                            res.push(item)
                        }
                    }
                    else res.push(item);
                })
            }
            setGetOptions(res);
        };
        
        fetchData();
    }, [options, _a?.fieldSource?.type, _a?.fCode,
        _a?.fieldSource?.type === 'api' ? (_a?.fieldSource?.depends?.length ? dependFields : null) : _a?.allFieldValues
    ])

    useEffect(()=>{
        if(!_a.allFieldValues) return;
        const currentValue = _a.allFieldValues[name]?.value;
        const isEmpty = val =>
            val === undefined ||
            val === null ||
            val === '' ||
            (Array.isArray(val) && val.length === 0);
        if(!isEmpty(currentValue)) {
            if(!getOptions.find(item=>Array.isArray(currentValue) ? currentValue.includes(item.value) : currentValue === item.value) && _a?.formRef) {
                //当前的值不属于options里面的，清空
                _a?.formRef.setFieldValue(name, undefined);
                _a.setAllFieldValues && _a.setAllFieldValues(prevData=>({
                    ...prevData,
                    [name]: {
                        value: undefined,
                        isRequired: prevData[name]?.isRequired,
                        type: prevData[name]?.type
                    }
                }))
            }
        }
    }, [getOptions])
        
    useEffect(()=>{
        //fieldSource: 通过api获取当前组件的数据，比如option
        if(_a?.fieldSource?.type === 'api' && _a?.fieldSource?.depends?.length) {
            let depend_fields = {};
            _a?.fieldSource?.depends?.forEach(item=>{
                depend_fields[item.fromField] = _a?.allFieldValues[item.fromField];
            })
            if (!shallowEqualIgnoreOrder(lastDependFields, depend_fields)) {
                setDependFields(depend_fields);
                setLastDependFields(depend_fields);
            }
        }
    }, [_a?.fieldSource, _a?.allFieldValues])

    useEffect(()=>{
        //otherCustom: 后端传的其他数据，其中有displayOnly，hidden等字段，控制组件的隐藏和只读。hidden时组件渲染但是不显示�?
        if(_a?.props?.hiddenOnly === true) {
            setFieldHidden(true);
        }
        else {
            setFieldHidden(false);
        }
    }, [_a?.props?.hiddenOnly])

    return !calVisible && !fieldHidden ? null : <Spin spinning={fieldLoading}><div style={{...wStyle, ...fieldHidden ? {
        visibility: 'hidden',
        opacity: 0,
        height: 0,
        overflow: 'hidden',
        padding: 0,
        margin: 0,
        border: 0
    } : {}}}>
        <Form.Item
            name={name}
            label={label && label.trim() ? <span style={labelStyle}>{item_layout === 'vertical' && item_colon ? label+": " : label}</span> : undefined}
            className={(!formStyle?.labelAlign && root_formStyle?.labelAlign === 'right') || formStyle?.labelAlign === 'right' ? 
                'ant-form-item-label-right' : ''}
            layout={item_layout}
            colon={item_colon}
            rules={required ? [{ required: true, message: requiredText}] : []}
        >
            <Radio.Group
                style={{
                    display: 'flex',
                    flexDirection: inline === 'Yes' ? 'row' : 'column',
                    gap: optionType === 'default' || inline === 'No' ? optionGap : '0'
                }}
                optionType={optionType === 'default' || inline === 'No' ? 'default' : 'button'}
                buttonStyle={optionType.includes('outline') ? 'outline' : 'solid'}
                onChange={(val)=>{
                    _a.setAllFieldValues && _a.setAllFieldValues(prevData=>({
                        ...prevData,
                        [name]: {
                            value: val.target.value,
                            isRequired: prevData[name]?.isRequired,
                            type: prevData[name]?.type
                        }
                    }))
                }}
                disabled={disabled}
            >
                {
                    getOptions?.map((item, ind)=>{
                        return <Radio key={ind} value={item.value}><p
                            style={optionLabelStyle}
                        >
                            {item.label}
                        </p></Radio>
                    })
                }
            </Radio.Group>
        </Form.Item>
    </div></Spin>;
}




